/**
 * Constantes de traducción para tipos y tamaños de naves
 * Consolidadas desde ShipsPage.tsx y ShipStats.tsx
 */

export const TYPE_TRANSLATIONS: Record<string, string> = {
  'combat': 'Combate',
  'transport': 'Transporte',
  'exploration': 'Exploración',
  'industrial': 'Industrial',
  'support': 'Apoyo',
  'competition': 'Competición',
  'ground': 'Terrestre',
  'multi': 'Multirol',
  'cargo': 'Carga',
  'military': 'Militar',
  'starter': 'Iniciación',
  'racing': 'Carreras',
  'expedition': 'Expedición',
  'gunship': 'Nave de Combate',
  'bomber': 'Bombardero',
  'fighter': 'Caza',
  'heavy fighter': 'Caza Pesado',
  'light fighter': 'Caza Ligero',
  'interceptor': 'Interceptor',
  'corvette': 'Corbeta',
  'frigate': 'Fragata',
  'destroyer': 'Destructor',
  'cruiser': 'Crucero',
  'carrier': 'Portanaves',
  'undefined': 'Sin tipo',
  'COMBAT': 'Combate',
  'TRANSPORT': 'Transporte',
  'INDUSTRIAL': 'Industrial',
  'GROUND': 'Terrestre',
  'EXPLORATION': 'Exploración',
  'SUPPORT': 'Apoyo',
  'MULTI': 'Multirol',
  'COMPETITION': 'Competición'
};

export const SIZE_TRANSLATIONS: Record<string, string> = {
  'vehicle': 'Vehículo',
  'V': 'Vehículo',
  'snub': 'Snub',
  'N': 'Snub',
  'small': 'Pequeño',
  'S': 'Pequeño',
  'medium': 'Mediano',
  'M': 'Mediano',
  'large': 'Grande',
  'L': 'Grande',
  'capital': 'Capital',
  'C': 'Capital',
  'Vehicle': 'Vehículo',
  'Small': 'Pequeño',
  'Medium': 'Mediano',
  'Large': 'Grande',
  'Capital': 'Capital'
};

export const SIZE_ORDER: Record<string, number> = {
  'vehicle': 1,
  'V': 1,
  'snub': 2,
  'N': 2,
  'small': 3,
  'S': 3,
  'medium': 4,
  'M': 4,
  'large': 5,
  'L': 5,
  'capital': 6,
  'C': 6
};

export const PRODUCTION_STATUS_TRANSLATIONS: Record<string, string> = {
  'flight-ready': 'Lista para Volar',
  'in-concept': 'En Concepto'
};
